import { IAutoMapper } from "../interfaces";

export const mapMemberTimelineItems = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "MemberTimelineItem")
    .forMember("specificDay", o => o.specificDay)
    .forMember("timelineGroup", o => o.timelineGroup);
};
